import React from "react";
import { Helmet } from "react-helmet";
import TopBar from "../topbar/Topbar";
import Sidebar from "../sidebar/Sidebar";
import { useCookie } from "../../utils";
import { Nav, Tab } from "react-bootstrap";
import "../attendance/attendance.css";
import { PayeeScheduleComponent } from "./PayeeScheduleComponent";
import { LoanScheduleComponent } from "./LoanScheduleComponent";
import { LeaveScheduleComponent } from "./LeaveSchedueComponent";

const CustomReports = () => {
  const branch_id = useCookie("branch_id");

  return (
    <body>
      <Helmet>
        <meta charSet="utf-8" />
        <meta name="robots" content="noindex, nofollow"></meta>
        <title>InvexERP</title>
      </Helmet>
      <div className="main-wrapper">
        <TopBar />
        <Sidebar />
        <section className="bg-white page-header position-relative w-100 page-header-2">
          <div className="page-wrapper">
            <div className="d-flex w-100  m-0 p-0 align-items-center justify-content-between gap-5">
              <div className="">
                <h4 className="page-title page-title-alt fw-bold">
                  Custom Report
                </h4>
                <p className="page-paragraph">
                  All Custom Report are listed here.
                </p>
              </div>
            </div>
          </div>
        </section>
        <div className="page-wrapper" style={{ paddingTop: 15 }}>
          <div className="content container-fluid">
            <Tab.Container id="left-tabs-example" defaultActiveKey="payE">
              <Nav variant="pills">
                <Nav.Item>
                  <Nav.Link eventKey="payE">
                    <span className="fw-bold">Payee Schedule</span>
                  </Nav.Link>
                </Nav.Item>
                <Nav.Item>
                  <Nav.Link eventKey="loan">
                    <span className="fw-bold">Loans Schedule</span>
                  </Nav.Link>
                </Nav.Item>
                <Nav.Item>
                  <Nav.Link eventKey="leave">
                    <span className="fw-bold">Leave Schedule</span>
                  </Nav.Link>
                </Nav.Item>
              </Nav>

              <Tab.Content className="pt-2">
                <Tab.Pane eventKey="payE">
                  <PayeeScheduleComponent branch_id={branch_id} />
                </Tab.Pane>
                <Tab.Pane eventKey="loan">
                  <LoanScheduleComponent branch_id={branch_id} />
                </Tab.Pane>
                <Tab.Pane eventKey="leave">
                  <LeaveScheduleComponent branch_id={branch_id} />
                </Tab.Pane>
              </Tab.Content>
            </Tab.Container>
          </div>
        </div>
      </div>
    </body>
  );
};

export default CustomReports;
